// extracted by mini-css-extract-plugin
export default {"wrapper":"XD-z","viewport":"YD-z","container":"ZD-z","slide":"_D-z"};